






import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import router from './router'

@Component({ name: 'app' })

export default class App extends Vue {
  private jumpMap = [
    { role: '普通助教', to: '/student/list' },
    { role: '质检专员', to: '/student/list' },
    { role: '运营实习生', to: '/student/list' },
    { role: '运营实习生班长', to: '/student/list' },
    { role: 'supervisor', to: '/student/list' },
    { role: 'admin', to: '/employeeRole/employee_role' }
  ]

  created () {
    this.islogin()
  }

  private jumpToPage () {
    const roles = UserModule.roles
    for (const item of this.jumpMap) {
      const { role, to } = item
      const path: any = sessionStorage.getItem('path')
      const query: any = sessionStorage.getItem('query')
      if (path) {
        if (query) { // 刷新浏览器定位路由
          this.$router.push({ path: path, query: JSON.parse(query) })
        } else {
          this.$router.push({ path: path })
        }
      } else {
        if (roles.indexOf(role) !== -1) {
          this.$router.push({ path: to })
          return
        } else {
          this.$router.push({ path: '/home' })
        }
      }
    }
  }

  private async islogin () {
    if (UserModule.roles.length === 0 && !UserModule.isLogin) {
      await UserModule.GetUserInfo()
      const roles = UserModule.roles
      PermissionModule.GenerateRoutes(roles)
      router.addRoutes(PermissionModule.dynamicRoutes)
      await this.jumpToPage()
      await UserModule.GetMessageIsRead()
    }
  }
}
